import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div.attrs(({ $align, $textColor, $fontSize }) => ({
  align: $align,
  textColor: $textColor || "#000",
  fontSize: $fontSize || "1rem",
}))`
  max-width: ${({ $align }) =>
    $align === "full" ? "1920px" : $align === "wide" ? "1180px" : "500px"};
  color: ${({ $textColor }) =>
    `var(--color-${$textColor}, var(--color-black))`};
  font-size: ${({ $fontSize }) => $fontSize};
  gap: 15px;
  width: 100%;
  & .wp-block-navigation .wp-block-navigation-item__content {
    font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
    padding-bottom: 5px;
    width: 100%;
  }
  @media (hover: hover) {
    & .wp-block-navigation .wp-block-navigation-item__content {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const Navigation = ({
  content,
  align,
  parsedFontSize,
  textColor,
  className,
}) => {
  return (
    <Wrapper
      className={className}
      $align={align}
      $fontSize={parsedFontSize}
      $textColor={textColor}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

Navigation.propTypes = {
  content: PropTypes.node,
  align: PropTypes.string,
  parsedFontSize: PropTypes.string,
  textColor: PropTypes.string,
  className: PropTypes.string,
};

export default Navigation;
